import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Icon } from '../../Elements/Elements';

import classes from './ArrowDropdownButton.module.scss';

const ArrowDropdownButton = ({ onClick, manyTabs }) => {
  return (
    <button
      type="button"
      className={classes.arrowDropdownButton}
      onClick={onClick}
    >
      <Icon
        icon={'Icn_Arrow-1'}
        className={cn(
          classes.iconArrowDropdown,
          manyTabs && classes.iconVisible
        )}
      />
    </button>
  );
};

ArrowDropdownButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  manyTabs: PropTypes.bool
};

export default ArrowDropdownButton;
